import { createContext } from 'react';
import { CollapseDrawerContextProps } from './types';
import { DEFAULT_STATE } from './constants';

export const CollapseDrawerContext = createContext<CollapseDrawerContextProps>(DEFAULT_STATE);
